import styled from 'styled-components';
import { Form } from '@unform/web';


export const Wrapper = styled.div`
    display:flex;
    flex-direction: column;
`

export const WrapperTables = styled.div`
    margin:3px 0
`

export const Header = styled(Form)`
display:flex;
flex-direction:column;
.MuiFormControl-root{
    margin-bottom:5px;
}
`